import React from 'react'
import PropTypes from 'prop-types'
import styled, {injectGlobal, keyframes} from 'styled-components'
import { CSSTransition } from 'react-transition-group'

const Notification = (props) => {
    const {
        position,
        top,
        left,
        maxWidth,
        message,
    } = props

    return (
        <NotificationWrapper
            style={{top: top, left: left}}
            position={position}>
            <CSSTransition timeout={500} classNames={'bounce'} {...props}>
                <ArrowBox
                    maxWidth={maxWidth}
                    position={position}>
                    {message}
                </ArrowBox>
            </CSSTransition>
        </NotificationWrapper>
    )
}


Notification.propTypes = {
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number,
    message: PropTypes.string,
}

export default Notification

const bounceInKeyframes = keyframes`
      0%, 50%, 100% {
          -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
          transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
      }
      0% {
          opacity: 0;
          transform: scale3d(.3, .3, .3);
      }
      50% {
          transform: scale3d(1.1, 1.1, 1.1);
      }
      100% {
          opacity: 1;
          transform: scale3d(1,1,1);
      }
`

const bounceOutKeyframes = keyframes`
      0%, 50%, 100% {
          -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
          transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
      }
      0% {
          opacity: 1;
          transform: scale3d(1,1,1);
      }
      50% {
          transform: scale3d(1.1, 1.1, 1.1);
      }
      100% {
          opacity: 0;
          transform: scale3d(.3, .3, .3);
      }
`

const NotificationTheme = {
    left: {
        transform: 'translate(-100%, -50%)',
    },
    right: {
        transform: 'translate(0, -50%)',
    },
    bottom: {
        transform: 'translate(-50%, 0)',
    },
    top: {
        transform: 'translate(-50%, -100%)',
    },
}

const ArrowBox = styled.div`
    padding: 10px;
    position: relative;
    color: white;
    background-clip: padding-box;
    background: rgba(0,0,0,0.75);
    border: 1px solid transparent;
    border-radius: 3px;
    font-size: 65%;
    width: ${props => props.maxWidth}px;
    text-align: center;
    &:after {
        background-clip: padding-box;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: transparent;
        border-width: 10px;
        ${props => ArrowBoxTheme[props.position].attributes}
    }
`

const NotificationWrapper = styled.div`
    position: absolute;  
    z-index: 1;
    transform: ${props => NotificationTheme[props.position].transform};
    ${props => props.position === 'right' && 'margin-left: 40px;'}
    ${props => props.position === 'left' && 'margin-left: -40px;'}
    ${props => props.position === 'bottom' && 'margin-top: 40px;'}
    ${props => props.position === 'top' && 'margin-top: -40px;'}
`

const ArrowBoxTheme = {
    left: {
        attributes: 'left: 100%; top: 50%; border-left-color: rgba(0,0,0,0.75); margin-top: -10px;',
    },
    right: {
        attributes: 'right: 100%; top: 50%; border-right-color: rgba(0,0,0,0.75); margin-top: -10px;',
    },
    bottom: {
        attributes: 'bottom: 100%; left: 50%; border-bottom-color: rgba(0,0,0,0.75); margin-left: -10px;',
    },
    top: {
        attributes: 'top: 100%; left: 50%; border-top-color: rgba(0,0,0,0.75); margin-left: -10px;',
    },
}

injectGlobal`
    .bounce-enter {
        animation-duration: .5s;
        animation-fill-mode: both;
        animation-name: ${bounceInKeyframes};
    }
    .bounce-exit {
        animation-duration: .5s;
        animation-fill-mode: both;
        animation-name: ${bounceOutKeyframes};
    }
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Container/Molecules/Notification.jsx